import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.SET_SELECTED](state, cardId) {
    Vue.set(state, 'selectedCustomCardId', cardId);
  },

  [types.SET_CARDS](state, cardList) {
    Vue.set(state, 'customCardList', cardList);
  },

  [types.ADD_CARDS](state, cardList) {
    state.customCardList.push(...cardList);
  },

  [types.SET_CARD_PAGES](state, { cardId, pageList }) {
    state.customCardList.forEach((card) => {
      if (card.id === cardId) {
        Vue.set(card, 'pages', pageList);
      }
    });
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/custom-cards/store/mutations.js